import React from "react";
import CKEditor from "ckeditor4-react";
import * as Entities from "entities";

export default function CKEditor4({ field, form, config, disabled, ...rest }) {
  return (
    <div style={{ color: "black" }}>
      <CKEditor
        name={field.name}
        onBeforeLoad={CKEDITOR => (CKEDITOR.disableAutoInline = true)}
        data={Entities.decodeHTML5(field.value)}
        config={{
          // autoGrow_maxHeight: 10,
          uiColor: "#cccccc",
          ...config
        }}
        onChange={evt =>
          form.setFieldValue(
            field.name,
            Entities.encodeHTML5(evt.editor.getData())
          )
        }
        readOnly={disabled}
        {...rest}
      />
    </div>
  );
}
